export default "__VITE_ASSET__473ec851__"